import { CircularProgress } from '@mui/material'
import React from 'react'

import ListEditor from '../common/ListEditor'
import useProducts from '../hooks/api/useProducts'
import SettingsFooter from './shared/SettingsFooter'
import useAlert from '../hooks/useAlert'
import DragAndDropInstructions from './shared/DragAndDropInstructions'

// TECH-DEBT: move all these MAX constants to the contants folder
const MAX_ALLOWED_PRODUCTS = 20

const EMPTY_PRODUCT = {
  name: '',
  price: 0,
  billingCycleTypeId: 1,
}

export const ProductsForm = ({ products, setProducts, billingCycleTypes }) => {
  return (
    <>
      <DragAndDropInstructions sx={{ mb: 3 }} />
      <ListEditor
        list={products}
        maxLength={MAX_ALLOWED_PRODUCTS}
        editableKeys={[
          {
            label: 'Name',
            key: 'name',
          },
          {
            label: 'Price',
            key: 'price',
            type: 'number',
            adornment: '$',
          },
          {
            label: 'Billing Cycle',
            key: 'billingCycleTypeId',
            isDropdown: true,
            options: billingCycleTypes,
          },
        ]}
        onChange={setProducts}
        emptyItem={EMPTY_PRODUCT}
        canReorder
      />
    </>
  )
}

// ASK: ask about how we want to handle deleting products.
// Easiest is to just "archive" the product and not allow users to attach that product to deals
// but keep it on existing deals

const Products = () => {
  const {
    products,
    setProducts,
    isLoading,
    hasLoadError,
    saveProducts,
    billingCycleTypes,
  } = useProducts()

  const { createAlert, createGenericErrorAlert } = useAlert()
  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved products',
    })

  const onFailure = () => createGenericErrorAlert()

  const submit = () => {
    return saveProducts().then(onSuccess).catch(onFailure)
  }

  if (isLoading) return <CircularProgress />

  return (
    <>
      <ProductsForm
        products={products}
        setProducts={setProducts}
        billingCycleTypes={billingCycleTypes}
      />
      <SettingsFooter saveButton={{ onClick: submit }} />
    </>
  )
}

export default Products
